export type AnalyticsEvent =
  | 'signup'
  | 'signup-confirmed'
  | 'login'
  | 'goal-created'
  | 'onboarding-started'
  | 'onboarding-step'
  | 'onboarding-skipped'
  | 'onboarding-completed'
  | 'onboarding-revisited'
  | 'checkout-opened'
  | 'checkout-loaded'
  | 'checkout-completed'
  | 'subscription-active';

type Umami = NonNullable<Window['umami']>;

// The tracker is a deferred script, so on a cold load fetchMe can resolve before it has
// executed. Queue the call on the script's load event; if Umami is absent or blocked, no-op.
function withUmami(fn: (umami: Umami) => void) {
  if (window.umami) return fn(window.umami);
  document
    .querySelector('script[src$="umami.is/script.js"]')
    ?.addEventListener('load', () => window.umami && fn(window.umami), { once: true });
}

export function useAnalytics() {
  function track(event: AnalyticsEvent, data?: AnalyticsData) {
    withUmami((umami) => umami.track(event, data));
  }

  // Attaches the user to the current session as session data. Umami's session id is
  // hash(website, ip, ua, salt, distinctId), so the string form identify(id) would start a
  // new session at login and break the funnel; the data-only form keeps the session intact.
  function identify(userId: number) {
    withUmami((umami) => umami.identify({ user_id: userId }));
  }

  return { track, identify };
}
